/**
 * Collection of simple string validation in Javascript using regular expressions (regex)
 * Gin Valeriano
 */

const Validator ={ 
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    isset: /^$|\s/
}

export default Validator;


// WEBPACK FOOTER //
// ./src/model/Validator.js